import React from 'react';
import { useNavigate } from 'react-router-dom';
// import TestWorkflowIcon from '../assets/testWorkflowIcon.png'; // Update path to your icon
import TestWorkflowIcon from '../../assets/icons/test_workflow.svg';

const TestWorkflowButton = ({
  setSnackbarMessage,
  setSnackbarSeverity,
  setSnackbarOpen,
  workflowId,
  publishedTemplate,
  currentnodes,
  nodes,
  heighlightNodes,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // console.log(currentnodes, nodes);
    if (publishedTemplate && currentnodes.length == nodes.length) {
      setSnackbarOpen(false);
      // navigate(`/workflow/preview/${workflowId}`);
      window.location.href = `/workflow/preview/${workflowId}`;
    } else {
      if (currentnodes != nodes) {
        setSnackbarMessage('Please save the workflow first.');
      } else {
        setSnackbarMessage(
          'All templates must be published before running a test workflow.'
        );
        heighlightNodes();
      }

      setSnackbarSeverity('info');
      setSnackbarOpen(true);
    }
  };

  return (
    <button
      style={{
        position: 'fixed',
        bottom: '10px',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '8px 16px',
        backgroundColor: ' var(--primary-color)',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        zIndex: 1000,
      }}
      onClick={handleClick}
    >
      <img
        src={TestWorkflowIcon}
        alt="Test Workflow"
        style={{ marginRight: '8px', width: '20px', height: '20px' }}
      />
      Test workflow
    </button>
  );
};

export default TestWorkflowButton;
